import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';

interface Props {
    id?: string;
    title: string;
    desc: string;
    footer?: string;
}
const HighlightTextAni: React.FC<Props> = ({ title = '', desc = '', id = '', footer = '' }) => {
    const sectionRef = useRef<HTMLDivElement>(null);
    const screenRef = useRef<HTMLDivElement>(null);

    const [enter, setEnter] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!sectionRef.current) return;
        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: sectionRef.current.offsetHeight > window.innerHeight ? window.innerHeight : sectionRef.current?.offsetHeight,

            duration: window.innerHeight * 1.1,
            onProcess: (process: number) => {
                if (process <= 0) {
                    setEnter(false);
                }
            },
            onEnter: () => {
                setEnter(true);
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, []);

    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!infoRef.current) return;
        const screen = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            asyncFromTo: [
                [infoRef.current, { opacity: 0 }, { opacity: 0 }, 0.2],
                [infoRef.current, { opacity: 0 }, { opacity: 1 }, 0.3],
                [`.delta-pro-ultra-x-ListAni`, { y: 0 }, { y: 0 }, 0.5],
            ],
            asyncTimeLine: [0, 0.2, 1],
        });
        return () => {
            screen.destroy?.();
        };
    }, []);
    return (
        <section
            className={`${css.section} delta-pro-ultra-x-ListAni GtmModuleData-section ${id}`}
            id={id}
            data-section-id={css.section}
            data-section-title={title}
            ref={sectionRef}
        >
            <div className={`listAni-container ${enter ? 'enter' : ''}`} ref={screenRef}>
                <div className="info" ref={infoRef}>
                    {title && <div className="highlight-title">{title}</div>}
                    {desc && <div className="highlight-desc">{desc}</div>}
                </div>
                {footer && <p className={`footer ${enter ? 'enter' : ''}`}>{footer}</p>}
            </div>
        </section>
    );
};

export default HighlightTextAni;
